module.exports = __webpack_public_path__ + "img/anti-counterfeiting-title.a4eac0fa.png";